const shopcartActions = {
	ADD_ITEM_TO_CART: 'ADD_ITEM_TO_CART',
	CALCULATE_TOTAL_QUANTITY: 'CALCULATE_TOTAL_QUANTITY',
	SET_ITEM_QUANTITY: 'SET_ITEM_QUANTITY',
	REMOVE_ITEM: 'REMOVE_ITEM',
	CLEAR_CART: 'CLEAR_CART'
};

export default shopcartActions;